export enum WidgetLayout {
  DEFAULT = 'default',
  HORIZONTAL = 'horizontal',
}

export enum ExpanderStatus {
  OPEN = 'open',
  CLOSE = 'close',
}

export enum WidgetTheme {
  LIGHT = 'theme--light',
  DARK = 'theme--dark',
}

export enum LocationType {
  ORIGIN = 'origin',
  DESTINATION = 'destination',
}

export enum SelectorType {
  TRIP_TYPE = 'tripType',
  TRAVEL_DATES = 'travelDates',
  PAX = 'pax',
  DISCOUNT_CODE = 'discountCode',
  ORIGIN = LocationType.ORIGIN,
  DESTINATION = LocationType.DESTINATION,
  LOCATION_COMBO = 'locationCombo',
}

export type GlobalBookingWidgetSelectionChangeMap = Partial<Record<SelectorType, boolean>>;
